/* --- SHUBHAM CREATION - COLLECTION CIRCLES DRAG-TO-SCROLL JS --- */

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.shubham-collection-circles-container');

  sliders.forEach(slider => {
    let isDown = false;
    let isDragging = false; 
    let startX;
    let scrollLeft;

    // Mouse Down (Start Drag)
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      isDragging = false; // Reset the drag status on every new click
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    // Mouse Leave (Cancel Drag)
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    // Mouse Up (End Drag)
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    // Mouse Move (Dragging)
    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // The '2' is the scroll speed multiplier
      
      // If the mouse moves more than 5 pixels, flag it as a drag instead of a click
      if (Math.abs(walk) > 5) {
        isDragging = true; 
      }
      
      slider.scrollLeft = scrollLeft - walk;
    });
    
    // Prevent accidentally clicking a link while dragging
    slider.querySelectorAll('.shubham-circle-item').forEach(item => {
        // Stop default browser ghost-image dragging
        item.addEventListener('dragstart', (e) => e.preventDefault());
        
        item.addEventListener('click', (e) => {
            // If the user was dragging, stop the link from opening
            if (isDragging) {
                e.preventDefault();
            }
        });
    });
  });
});